// extracted by mini-css-extract-plugin
export default {"requiredVendorsSection":"requiredVendorsSection__Y2YzY","vendorCard":"vendorCard__NmIxM"};